import {createAction} from '@reduxjs/toolkit'

export const updateArchivedJourneys = createAction(
  'archived_journeys/save',
  (data) => ({
    payload: data
  })
)
